import Image from 'next/image'
import styled from 'styled-components'
import appStoreButtonImage from '../../../assets/landing/appStoreButton.svg'
import googlePlayButtonImage from '../../../assets/landing/googlePlayButton.svg'
import appMockupImage from '../../../assets/ai-studio-landing/app_mockup.png'

const SectionWrapper = styled.section`
  width: 100%;
  min-height: 804px;
  background: linear-gradient(180deg, #190038 0%, #550091 55%, #D100E4 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 20px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 60px 20px;
    min-height: auto;
  }
`

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  gap: 60px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`

const TextContent = styled.div`
  flex: 1;
  max-width: 555px;
  display: flex;
  flex-direction: column;
  gap: 26px;

  @media (max-width: 1024px) {
    align-items: center;
  }
`

const Title = styled.h2`
  color: white;
  font-size: 48px;
  font-weight: 500;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const Description = styled.p`
  color: white;
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 322px;
  height: 50px;
  background: linear-gradient(270deg, #FF996E 0%, #FF5565 37%, #FF4576 75%, #FF5E84 100%);
  border-radius: 100px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`

const StoreButtonsContainer = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`

const StoreButton = styled.a`
  display: block;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  img {
    display: block;
    height: 32px;
    width: auto;
  }
`

const ImageContainer = styled.div`
  position: relative;
  width: 568px;
  height: 707px;
  border-radius: 20px;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 500px;
    height: 600px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    height: 450px;
  }
`

const DesignAnywhereSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <ContentContainer>
        <TextContent>
          <Title>Design Anywhere with DecorMatters AI.</Title>
          <Description>
            Create, edit, and refine real room designs with DecorMatters' AI interior design tools — available on iOS, Android, and web. Design from any device.
          </Description>
          <ActionButton
            href="https://decormatters.app.link/WTHVetOFCMb"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download the DecorMatters App
          </ActionButton>
          <StoreButtonsContainer>
            <StoreButton
              href="https://apps.apple.com/us/app/decor-matters-design-shop/id1168709467"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appStoreButtonImage} alt="Download on the App Store" />
            </StoreButton>
            <StoreButton
              href="https://play.google.com/store/apps/details?id=com.decormatters.prod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlayButtonImage} alt="Get it on Google Play" />
            </StoreButton>
          </StoreButtonsContainer>
        </TextContent>

        <ImageContainer>
          <Image
            src={appMockupImage}
            alt="DecorMatters App"
            layout="fill"
            objectFit="cover"
          />
        </ImageContainer>
      </ContentContainer>
    </SectionWrapper>
  )
}

export default DesignAnywhereSection
